/**
 * Carousel — contained Glider.js slider.
 *
 * Supports any number of instances on a page, honors slides_to_show,
 * carousel_controls, loop and autoplay, and initializes inside the ACF
 * block preview as well as on the front end.
 */
(function () {
	'use strict';

	var AUTOPLAY_DELAY = 5000;

	function prefersReducedMotion() {
		return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
	}

	function initCarousel(root) {
		if (!root || typeof window.Glider === 'undefined') {
			return;
		}

		var track = root.querySelector('.carousel-track');

		if (!track || track.classList.contains('glider-loaded')) {
			return;
		}

		var show = parseInt(root.getAttribute('data-slides-to-show'), 10) || 1;
		var controls = root.getAttribute('data-controls') || 'both';
		var loop = 'yes' === root.getAttribute('data-loop');
		var autoplay = 'yes' === root.getAttribute('data-autoplay');

		show = Math.max(1, Math.min(4, show));

		var wantsDots = 'dots' === controls || 'both' === controls;
		var wantsArrows = 'arrows' === controls || 'both' === controls;

		var dots = wantsDots ? root.querySelector('.carousel-dots') : null;
		var prev = wantsArrows ? root.querySelector('.carousel-prev') : null;
		var next = wantsArrows ? root.querySelector('.carousel-next') : null;

		// Glider builds the dot buttons itself from this container, so the dot
		// count always matches the slide count.
		if (dots) {
			dots.innerHTML = '';
		}

		var options = {
			slidesToShow: 1,
			slidesToScroll: 1,
			draggable: true,
			scrollLock: true,
			rewind: loop,
			responsive: [
				{
					breakpoint: 576,
					settings: {
						slidesToShow: Math.min(2, show),
						slidesToScroll: Math.min(2, show)
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: show,
						slidesToScroll: show
					}
				}
			]
		};

		if (dots) {
			options.dots = dots;
		}

		if (prev && next) {
			options.arrows = { prev: prev, next: next };
		}

		var glider = new window.Glider(track, options);

		// Flip the pre-init grid off only once Glider owns the layout.
		track.classList.add('glider-loaded');

		if (!autoplay || prefersReducedMotion()) {
			return;
		}

		var timer = null;

		function stop() {
			if (timer) {
				window.clearInterval(timer);
				timer = null;
			}
		}

		function start() {
			if (timer) {
				return;
			}
			timer = window.setInterval(function () {
				glider.scrollItem('next');
			}, AUTOPLAY_DELAY);
		}

		root.addEventListener('mouseenter', stop);
		root.addEventListener('mouseleave', start);
		root.addEventListener('focusin', stop);
		root.addEventListener('focusout', start);

		start();
	}

	function initAll(scope) {
		var context = scope || document;
		var carousels = context.querySelectorAll('.carousel-contain');
		var i;

		for (i = 0; i < carousels.length; i++) {
			initCarousel(carousels[i]);
		}
	}

	if ('loading' === document.readyState) {
		document.addEventListener('DOMContentLoaded', function () {
			initAll(document);
		});
	} else {
		initAll(document);
	}

	// ACF block preview inside Gutenberg.
	if (window.acf) {
		window.acf.addAction('render_block_preview/type=carousel', function ($block) {
			var el = $block && $block[0] ? $block[0] : $block;

			if (!el || !el.querySelectorAll) {
				return;
			}

			initAll(el);
		});
	}
})();
